/*
  Where each Ask Cadenza tool's data can be seen in the app, so the "what it
  read" lines under an answer can link to the records. Tools with no page of
  their own (read_guide) have no link. The target is a page plus, where the
  tool's input names one, the scenario, run or heap to open it on.
*/
const TOOL_PAGES = {
  list_scenarios: "/project-details",
  get_scenario_config: "/project-details",
  compare_scenario_configs: "/project-details",
  list_simulations: "/results",
  get_simulation_status: "/results",
  get_simulation_summary: "/results",
  get_simulation_logs: "/results",
  query_results: "/results",
  compare_simulations: "/results",
  query_snapshot: "/results",
  get_simulation_economics: "/analysis/npv",
  get_econ_config: "/analysis/npv",
  query_heap: "/heaps",
  get_heap_layout: "/heaps",
  get_block_model: "/heaps",
  get_mine_schedule: "/heaps",
  get_leach_schedule: "/leaching",
  list_ensembles: "/analysis/ensembles",
  get_ensemble: "/analysis/ensembles",
  list_closure_jobs: "/analysis/closure",
  get_closure_job: "/analysis/closure",
  query_closure_results: "/analysis/closure",
  list_export_templates: "/results",
  show_chart: "/results",
  list_lab_tests: "/lab-tests",
  get_kinetics_fit: "/kinetics-fitting",
  list_geode_models: "/simulation-config",
  get_geode_model: "/simulation-config",
  list_operational_logs: "/operational-data",
  query_operational_data: "/operational-data",
  list_maintenance_assets: "/maintenance",
  list_maintenance_logs: "/maintenance",
  list_tasks: "/management",
};

const firstString = (value) =>
  typeof value === "string" && value ? value : undefined;

/**
 * The link target for a tool call, or null when it has none. A failed or
 * still-running call has nothing to show, so it gets no link either.
 */
export const sourceFor = (tool) => {
  const to = TOOL_PAGES[tool?.name];
  if (!to || tool.pending || tool.ok === false) return null;
  const input = tool.input || {};
  return {
    to,
    scenarioId: firstString(input.scenarioId),
    simulationId:
      firstString(input.simulationId) ||
      (Array.isArray(input.simulationIds) ? firstString(input.simulationIds[0]) : undefined),
    heapId: firstString(input.heapId),
  };
};
